<template>
  <div style="height: 700px; overflow: auto">
    <Form :label-width="120" class="order-details">
      <Divider orientation="left">订单详情</Divider>
      <div class="from-div">
        <Row>
          <Col span="6">
            <FormItem :label="$t('order_number')">
              <Input disabled v-model="dataDetails.airway_bill_number"></Input>
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem :label="$t('amazon')">
              <Input disabled v-model="dataDetails.amazon_id"></Input>
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem :label="$t('souqNum')">
              <Input disabled v-model="dataDetails.souq_id"></Input>
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem :label="$t('createTime')">
              <Input disabled v-model="dataDetails.create_time"></Input>
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem :label="$t('clientName')">
              <Select v-model="dataDetails.client_id" disabled="disabled">
                <Option
                  v-for="item in objUserClient"
                  :value="item.id"
                  :key="item.id"
                  >{{ item.shipper_account }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem :label="$t('orderType')">
              <Input :value="dataDetails.status" disabled></Input>
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem :label="$t('invoicePCS')">
              <Input :value="dataDetails.pcs" disabled></Input>
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem :label="$t('store_name')">
              <Input :value="dataDetails.store_name" disabled></Input>
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem :label="$t('courier')">
              <Input :value="dataDetails.courier" disabled></Input>
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem :label="$t('site_name')">
              <Input :value="dataDetails.site_name" disabled></Input>
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem :label="$t('label_url')">
              <Input :value="dataDetails.label_url" disabled></Input>
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem :label="$t('order_desc')">
              <Input :value="dataDetails.remarks" disabled></Input>
            </FormItem>
          </Col>
        </Row>
      </div>
      <Divider orientation="left">Sku详情列表</Divider>
      <div class="from-div">
        <Table border :columns="tableTitle" :data="dataDetails.details"></Table>
      </div>
    </Form>
  </div>
</template>

<script>
import basic from "@/utils/basic";

export default {
  props: {
    dataDetails: {
      type: Object,
    },
  },
  data() {
    return {
      objUserClient: {},
      objAccount: {},
    };
  },
  computed: {
    tableTitle() {
      let columns = [];
      columns.push({
        title: this.$t("invoiceName"),
        key: "sku_name",
        align: "center",
      });
      columns.push({
        title: this.$t("invoicePCS"),
        key: "pcs",
        align: "center",
      });
      columns.push({
        title: this.$t("invoiceWeight"),
        key: "weight",
        align: "center",
      });
      columns.push({
        title: this.$t("invoiceDescription"),
        key: "sku",
        align: "center",
      });
      columns.push({
        title: this.$t("picked"),
        key: "picked",
        align: "center",
      });
      return columns;
    },
  },
  mounted() {
    this.objUserClient = basic.objUserClient();
    this.objAccount = basic.objAccount();
  },
};
</script>

<style lang="less" >
.from-div {
  border: 1px solid #e8eaec;
  padding: 30px 10px 10px;
  margin-top: -28px;
  border-top: none;
}
</style>
